export default __webpack_public_path__ + "static/media/astronomer.7cccdfaa.svg";